import { DatePicker, FormField, List, ListRow, Section, Select, Text } from '@ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSession } from '../../identity/session';
import { annualReportUrl, csvUrl, exportLists, listPermission, treatmentReportUrl } from '../api';
import { yearOptions } from '../format';
import styles from './ReportPages.module.css';

/** PDF reports, CSV lists and the way to the full export (EXP-001 – EXP-003). */
export function ReportsExportPage() {
  const { t } = useTranslation();
  const { can } = useSession();
  const thisYear = new Date().getFullYear();
  const [year, setYear] = useState(thisYear);
  const [from, setFrom] = useState(`${thisYear}-01-01`);
  const [to, setTo] = useState(`${thisYear}-12-31`);
  const lists = exportLists.filter((l) => can(listPermission[l]));
  const periodValid = from !== '' && to !== '' && from <= to;

  return (
    <div className={styles.page}>
      <div className={styles.columns}>
        <Section title={t('reports.pdf.annual')} variant="content">
          <div className={styles.form}>
            <FormField label={t('reports.year')}>
              {(p) => (
                <Select
                  {...p}
                  value={String(year)}
                  onChange={(e) => setYear(Number(e.target.value))}
                  options={yearOptions(
                    thisYear,
                    Array.from({ length: 5 }, (_, i) => thisYear - i),
                  )}
                />
              )}
            </FormField>
            <a href={annualReportUrl(year)} target="_blank" rel="noreferrer">
              {t('reports.pdf.open')}
            </a>
          </div>
        </Section>
        {can('treatments.read') && (
          <Section title={t('reports.pdf.treatments')} variant="content">
            <div className={styles.form}>
              <FormField label={t('reports.pdf.from')}>
                {(p) => <DatePicker {...p} value={from} onChange={setFrom} />}
              </FormField>
              <FormField label={t('reports.pdf.to')}>
                {(p) => <DatePicker {...p} value={to} onChange={setTo} />}
              </FormField>
              {periodValid ? (
                <a href={treatmentReportUrl(from, to)} target="_blank" rel="noreferrer">
                  {t('reports.pdf.open')}
                </a>
              ) : (
                <Text size="sm" tone="danger">
                  {t('reports.pdf.periodInvalid')}
                </Text>
              )}
            </div>
          </Section>
        )}
      </div>
      {lists.length > 0 && (
        <Section title={t('reports.csv.title')}>
          <List>
            {lists.map((l) => (
              <ListRow
                key={l}
                title={t(`reports.lists.${l}`)}
                trailing={
                  <a
                    href={csvUrl(l)}
                    download
                    aria-label={`${t(`reports.lists.${l}`)}: ${t('reports.csv.export')}`}
                  >
                    {t('reports.csv.short')}
                  </a>
                }
              />
            ))}
          </List>
        </Section>
      )}
      {can('data.export') && (
        <Section title={t('reports.full.title')}>
          <List>
            <ListRow title={t('reports.full.toSettings')} href="/einstellungen/datenexport" />
          </List>
        </Section>
      )}
    </div>
  );
}
